import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-center flex-wrap",
  style: {"gap":"5px"}
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex align-center justify-space-between my-4" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "ml-2 mb-0" }, "Grupos", -1)
const _hoisted_7 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_8 = { class: "area-responsibles" }
const _hoisted_9 = ["onClick"]

import { ref, watch, withDefaults, onMounted } from 'vue';
import { MoleculeModal, MoleculeGroupModal } from '@/components/molecules';
import { Company, Group, User } from '@/core/model';
import { create, update } from '@/core/service/UserService';

import { getAll as groupAll } from '@/core/service/GroupService';
import { validateCPF, validateEmail } from '@/core/service/ValidateService';
import { Preloader } from '@/store';
import Swal from 'sweetalert2';
import {
  AtomInput,
  GroupIcon,
  AtomButton,
  SearchIcon,
  AtomCheckBox,
  AtomAccordion,
  AtomSelect,
} from '@/components/atoms';
import { computed } from 'vue';
import { Authentication } from '@/store';
import { IOptionsSelect } from '@/types';
import { getHeadquartersByUser, getSubsidiariesByHeadquartersId } from '@/core/service/CompanyService';

interface IProps {
  showModal: boolean;
  model?: User;
  companys: Company[];
  users: User[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeUserModal',
  props: {
    showModal: { type: Boolean, default: false },
    model: null,
    companys: null,
    users: null
  },
  emits: ['onHandleClose', 'addGroup', 'handleAddCompany'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, model?: User, companys: Company[], users: User[] };

const optionsFiliais = ref<IOptionsSelect[]>([]);
const filial = ref<number>();
const isAdd = ref<boolean>(false);


const showModalUser = ref<boolean>(false);

const optionsRole = computed(() => {
  if (Authentication.getters.isMaster.value) {
    return [
      { text: 'ADMIN', value: 'ADMIN' },
      // { text: 'MASTER', value: 'MASTER' },
    ] as IOptionsSelect[];
  } else if (Authentication.getters.isAdmin.value) {
    return [
      { text: 'GESTOR', value: 'MANAGER' },
      { text: 'COLABORADOR', value: 'collaborator'.toUpperCase() },
    ] as IOptionsSelect[];
  } else {
    return [{ text: 'COLABORADOR', value: 'collaborator'.toUpperCase() }] as IOptionsSelect[];
  }
});
const disabledButton = computed(() => {
  return (
    !data.value.name ||
    !data.value.civil_document ||
    !validateCPF(data.value.natural_persons_register) ||
    !data.value.phone ||
    !data.value.email ||
    (Authentication.getters.isAdmin.value && data.value.role == 'collaborator'.toUpperCase()
      ? !data.value.groups
      : false) ||
    !data.value.phone
  );
});

const groups = ref<Group[]>([]);
const search = ref<string>('');
const searchGroup = computed(() => {
  return search.value
    ? groups.value.filter((f) => f.name?.toUpperCase()?.includes(search.value.toUpperCase()))
    : groups.value;
});
const data = ref<User>({});

const matrizData = ref<Company>({});

function handleAddCompany(event: boolean) {
  if (event) {
    emit('handleAddCompany', event);
  }
  isAdd.value = false;
  showModalUser.value = false;
}

function loadSubisidiary() {
  getSubsidiariesByHeadquartersId(Number(matrizData.value.id)).then((f) => {
    optionsFiliais.value = f.data.map((x) => {
      return { text: x.fantasy_name, value: x.id };
    });
  });
}
function loadHeadQuarters() {
  getHeadquartersByUser(Number(Authentication.state.value.mkId)).then((f) => {
    matrizData.value = f.data;

    if (matrizData.value) loadSubisidiary();
  });
}

function addGroup(group: Group) {
  if (!data.value.groups) {
    data.value.groups = [];
    ('');
  }
  if (data.value.groups.filter((f) => f == group.id).length == 0) {
    data.value.groups.push(Number(group.id));
  } else {
    data.value.groups = data.value.groups.filter((f) => f != group.id);
  }
}
function handleAddOrUpdate() {
  Preloader.actions.ActionSetPreloader(true);

  if (data.value.civil_document)
    data.value.civil_document = data.value.civil_document?.split('.').join('').split('-').join('');

  if (data.value.natural_persons_register)
    data.value.natural_persons_register = data.value.natural_persons_register?.split('.').join('').split('-').join('');

  data.value.groups = groups.value.map((f) => Number(f.id));
  // data.value.role = Authentication.getters.isAdmin.value || Authentication.getters.isManager.value
  // ? 'collaborator'.toUpperCase()
  // : 'ADMIN'.toUpperCase();
  if (!data.value.id) {
    data.value.id = undefined;
    create(data.value)
      .then(() => {
        // Swall
        Swal.fire({
          title: 'Sucesso !',
          text: `Usuário ${data.value.name} foi criado com sucesso !`,
          icon: 'success',
        });
        emit('onHandleClose', true);
      })
      .finally(() => {
        Preloader.actions.ActionSetPreloader(false);
      });
  } else {
    update(data.value)
      .then(() => {
        // swall
        Swal.fire({
          title: 'Sucesso !',
          text: `Usuário ${data.value.name} foi atualizado com sucesso !`,
          icon: 'success',
        });
        emit('onHandleClose', true);
      })
      .finally(() => {
        Preloader.actions.ActionSetPreloader(false);
      });
  }
}
function clear() {
  data.value = {};
  emit('onHandleClose', false);
}

function loadGroup() {
  groupAll().then((f) => {
    groups.value = f.data.filter((f) => f.subsidiary_id == filial.value);
  });
}
watch(
  () => props.model,
  () => {
    if (props.model) {
      data.value = props.model;

      if (data.value.groups?.length) {
        filial.value = JSON.parse(JSON.parse(data.value.groups[0]['subsidiary_id']));
        data.value.groups = data.value.groups.map((x) => x['id']);
      }
    }
  }
);
watch(
  () => filial.value,
  () => {
    loadGroup();
  }
);
onMounted(() => {
  loadHeadQuarters();
});

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    width: "649px",
    onHandleConfirm: handleAddOrUpdate,
    onHandleCancel: clear,
    icon: "PeopleIcon",
    iconColor: "#5528B5",
    title: `${data.value.id ? 'Editar Usuário' : 'Cadastro de Usuário'} `,
    subtitle: 'Preencha todos os campos corretamente para cadastrar um novo usuário',
    show: __props.showModal,
    "btn-close-text": "Cancelar",
    "btn-confirm-text": "Salvar",
    btnConfitmDisabled: _unref(disabledButton)
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!data.value.id || (data.value.id && String(data.value.id) != _unref(Authentication).getters.getUser.value.id))
            ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                key: 0,
                disabled: !!data.value.id,
                maxWidth: '100%',
                label: "Perfil",
                modelValue: data.value.role,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.role) = $event)),
                options: _unref(optionsRole),
                hasError: !data.value.role,
                required: "",
                class: "mb-5",
                msgError: "Campo obrigatório"
              }, null, 8, ["disabled", "modelValue", "options", "hasError"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(AtomInput), {
            disabled: !!data.value.id,
            maxWidth: '100%',
            msgError: "Campo obrigatório",
            label: "Nome",
            modelValue: data.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.name) = $event)),
            hasError: !data.value.name,
            required: "",
            classes: "mb-5"
          }, null, 8, ["disabled", "modelValue", "hasError"]),
          _createVNode(_unref(AtomInput), {
            maxWidth: '100%',
            msgError: !data.value.email ? 'Campo obrigatório' : !_unref(validateEmail)(data.value.email) ? 'E-mail inválido' : '',
            placeholder: "Email",
            hasError: !data.value.email || !_unref(validateEmail)(data.value.email),
            label: "Email",
            disabled: !!data.value.id,
            type: "email",
            required: "",
            modelValue: data.value.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.email) = $event)),
            classes: "mb-5"
          }, null, 8, ["msgError", "hasError", "disabled", "modelValue"]),
          _createVNode(_unref(AtomInput), {
            mask: "(##) #####-####",
            maxWidth: '100%',
            msgError: "Campo obrigatório",
            label: "Telefone",
            hasError: !data.value.phone,
            required: "",
            modelValue: data.value.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.phone) = $event)),
            classes: "mb-5"
          }, null, 8, ["hasError", "modelValue"]),
          _createVNode(_unref(AtomInput), {
            disabled: !!data.value.id,
            mask: "###.###.###-##",
            maxWidth: '100%',
            hasError: !data.value.natural_persons_register || !_unref(validateCPF)(data.value.natural_persons_register),
            required: "",
            "msg-error": 
              !data.value.natural_persons_register
                ? 'Campo Obrigatório'
                : !_unref(validateCPF)(data.value.natural_persons_register)
                ? 'CPF inválido'
                : ''
            ,
            label: "CPF",
            modelValue: data.value.natural_persons_register,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.natural_persons_register) = $event)),
            classes: "mb-5"
          }, null, 8, ["disabled", "hasError", "msg-error", "modelValue"]),
          _createVNode(_unref(AtomInput), {
            disabled: !!data.value.id,
            maxWidth: '100%',
            msgError: "Campo obrigatório",
            label: "RG",
            hasError: !data.value.civil_document,
            required: "",
            modelValue: data.value.civil_document,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.civil_document) = $event)),
            classes: "mb-5"
          }, null, 8, ["disabled", "hasError", "modelValue"]),
          _createVNode(_component_v_divider),
          (data.value.role == 'collaborator'.toUpperCase())
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(GroupIcon)),
                    _hoisted_6
                  ]),
                  (_unref(Authentication).actions.hasPermission('/groups', 'CREATE'))
                    ? (_openBlock(), _createBlock(_unref(AtomButton), {
                        key: 0,
                        background: "white",
                        outlined: "",
                        size: "sm",
                        class: "pa-2 px-4 ms-4",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (showModalUser.value = true), ["prevent"]))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Novo Grupo ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                ((data.value.groups ?? []).length == 0)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_7, "* É obrigatório escolher ao menos um grupo para prosseguir com o cadastro"))
                  : _createCommentVNode("", true),
                _createVNode(_unref(AtomAccordion), {
                  title: "Filial",
                  "initial-show": !filial.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomSelect), {
                      modelValue: filial.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filial).value = $event)),
                      placeholder: "Filiais",
                      options: optionsFiliais.value
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["initial-show"]),
                _createVNode(_unref(AtomAccordion), {
                  title: "Grupos",
                  "initial-show": !!filial.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AtomInput), {
                      "append-icon": "",
                      prependIcon: "",
                      noBgPrependIcon: "",
                      noBorderPrependIcon: "",
                      placeholder: "Pesquisar",
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((search).value = $event)),
                      width: "100%",
                      classes: "w-100 my-3"
                    }, _createSlots({
                      prependIcon: _withCtx(() => [
                        _createVNode(_unref(SearchIcon))
                      ]),
                      _: 2
                    }, [
                      (search.value)
                        ? {
                            name: "appendIcon",
                            fn: _withCtx(() => [
                              _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = _withModifiers(
                      () => {
                        search.value = '';
                      }
                    , ["prevent","stop"]))
                              }, " X ")
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["modelValue"]),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchGroup), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(["d-flex align-center justify-space-between py-6 px-4 border rounded item-user mb-5", { active: data.value.groups?.find((f) => f === item.id) }]),
                          onClick: ($event: any) => (addGroup(item))
                        }, [
                          _createElementVNode("p", null, _toDisplayString(item.name), 1),
                          _createVNode(_unref(AtomCheckBox), {
                            onClick: ($event: any) => (addGroup(item)),
                            checked: !!data.value.groups?.find((f) => f === item.id)
                          }, null, 8, ["onClick", "checked"])
                        ], 10, _hoisted_9))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["initial-show"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_unref(MoleculeGroupModal), {
        modelValue: showModalUser.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showModalUser).value = $event)),
        users: [],
        companys: [],
        onHandleAddOrUpdate: handleAddOrUpdate,
        onHandleAddCompany: handleAddCompany
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["title", "show", "btnConfitmDisabled"]))
}
}

})